import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AppMetadataHandler } from 'app/BaseFramework';
import { PolicyService } from 'app/FunctionalModules';
import * as html2pdf from 'html2pdf.js';
import moment from 'moment';
@Component({
  selector: 'app-view-receipt',
  templateUrl: './view-receipt.component.html',
  styleUrls: ['./view-receipt.component.scss']
})
export class ViewReceiptComponent implements OnInit {

  constructor(public appMetadataHandler : AppMetadataHandler) { }

  paymentDetails;
  
  ngOnInit() {
  }
  downloadPDF()
  {
    const options = {
      margin: 10,
      filename: "receipt.pdf",
      image: {type: 'jpeg'},
      html2canvas:{},
      jsPDF:{orientation: 'Portrait'}
    };
    const content: Element= document.getElementById('receipt');
    html2pdf()
      .from(content)
      .set(options)
      .save();
  }
  printReceipt(receiptId)
  {
    var backup = document.body.innerHTML;
    var receiptContent = document.getElementById(receiptId).innerHTML;
    document.body.innerHTML = receiptContent;
    window.print();
    document.body.innerHTML=backup;
  }

 
  @Input() payloadData 
  
  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
    }
    else {
      dateString = '-'
    }
    return dateString
  }
}
